/** Подписи «Системы»: имена задач по-человечески, статусы и длительность */

import dayjs from 'dayjs';

import type {JobRunStatus} from '@services/system';

/** Известные задачи воркера; незнакомые показываем как есть */
export const JOB_LABELS: Record<string, string> = {
  expire_trials: 'Закрытие триалов',
  send_notification: 'Пуш-уведомления',
  send_reminders: 'Напоминания пациентам',
  sync_templates: 'Синхронизация шаблонов WhatsApp',
  cleanup_job_runs: 'Уборка журнала задач',
};

export const jobLabel = (name: string): string => JOB_LABELS[name] ?? name;

export const STATUS_META: Record<JobRunStatus, {label: string; className: string}> = {
  ok: {label: 'Успешно', className: 'bg-[#E6F4EC] text-[#1B7A54]'},
  failed: {label: 'Ошибка', className: 'bg-[#FBE9E7] text-[#C6362C]'},
  running: {label: 'Идёт', className: 'bg-[#EAF0FD] text-[#2C5CDB]'},
};

/** «840 мс», «12,4 с», «3 мин» */
export const fmtDuration = (ms: number | null): string => {
  if (ms === null) return '—';
  if (ms < 1000) return `${ms} мс`;
  if (ms < 60_000) return `${(ms / 1000).toLocaleString('ru-RU', {maximumFractionDigits: 1})} с`;
  return `${Math.round(ms / 60_000)} мин`;
};

/** «сегодня 14:20», «вчера 09:05», «12 сен 18:40» */
export const fmtWhen = (iso: string | null): string => {
  if (iso === null || iso === '') return '—';
  const d = dayjs(iso);
  if (d.isSame(dayjs(), 'day')) return `сегодня ${d.format('HH:mm')}`;
  if (d.isSame(dayjs().subtract(1, 'day'), 'day')) return `вчера ${d.format('HH:mm')}`;
  return d.format('D MMM HH:mm');
};
